export default (theme) => ({
  card: {
    boxShadow: 'none',
    borderRadius: 20,
    background: '#FFF',

    [theme.breakpoints.up(768)]: {
      borderRadius: 0,
      width: 215,
    },

    '& .MuiCardContent-root': {
      height: '100%',
      minHeight: 101,
      padding: '14px 30px',

      '&:last-child': {
        paddingBottom: '14px',
      },

      [theme.breakpoints.up(768)]: {
        padding: 0,
        minHeight: '100%',

        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },
  },
  cardHeader: {
    display: 'flex',
    gap: 32,
    flexDirection: 'row',

    [theme.breakpoints.up(768)]: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
      gap: 33,
      height: '100%',
    },
  },
  cardAvatar: {
    alignItems: 'center',
    background: '#FFF',
    border: '1px solid #D9D9D9',
    borderRadius: '50%',
    color: '#D9D9D9',
    display: 'flex',
    flexDirection: 'column',
    height: 73,
    justifyContent: 'center',
    width: 73,

    [theme.breakpoints.up(768)]: {
      width: 110,
      height: 110,
    },
  },
  cardAvatarFallback: {
    background: '#FFF',
  },
  cardAvatarImg: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
  },
  cardAvatarEmptyIcon: {
    display: 'none',
  },
  cardAvatarEmptyText: {
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '14.4px',
    textAlign: 'center',
    margin: 0,

    [theme.breakpoints.up(768)]: {
      margin: '0px 16px',
    },
  },
  cardHeaderInfo: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 4,
    justifyContent: 'center',

    [theme.breakpoints.up(768)]: {
      gap: 10,
      width: '100%',
      alignItems: 'center',
    },
  },
  cardHeaderInfoDescription: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardTitleText: {
    color: '#000',
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '21.6px',
    textAlign: 'center',
  },
  cardSubtitleText: {
    color: '#000',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16.8px',

    [theme.breakpoints.up(768)]: {
      fontSize: 16,
      lineHeight: '19.2px',
    },
  },
});
